import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as SlideActions from "Data/slides/SlideActions";

import Sidebar from "Components/Sidebar";
import PropertyPanel from "Components/PropertyPanel";

import Color from "Components/Properties/Inputs/Color";

class SlidePropertiesSidebar extends React.Component
{
    state = {
        data: this.props.slide.data
    };

    static propTypes = {
        slide: PropTypes.object.isRequired,

        onChanged: PropTypes.func.isRequired,
        onChanging: PropTypes.func.isRequired,
    };

    static getDerivedStateFromProps(props) {
        return {
            data: props.slide.data
        };
    }

    handleChangingData = (key, value) => {

        const newData = {
            ...this.state.data,
            [key]: value
        };

        this.setState({data: newData});
        this.props.onChanging(this.props.slide.id, { data: newData });
    };

    onBlur = () => {
        this.props.onChanged(this.props.slide.id);
    };

    render()
    {
        return <Sidebar>
            <PropertyPanel className='space-y-4' title='Background' defaultOpen>
                <div className='flex items-center'>
                    <div className='flex-1'>
                        Background color
                    </div>
                    {
                        <Color
                            value={this.state.data.backgroundColor ? this.state.data.backgroundColor.toString() : '#ffffff'}
                            onChange={e => this.handleChangingData('backgroundColor', e.target.value)}
                            onBlur={this.onBlur}
                        />
                    }
                </div>
            </PropertyPanel>
        </Sidebar>;
    }
}

const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    onChanged: SlideActions.slideChanged,
    onChanging: SlideActions.slideChanging,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SlidePropertiesSidebar);
